// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VisualPlaceholder_wrapper__VU0wc","innerWrapper":"VisualPlaceholder_innerWrapper__R8j3m"};